import { render, staticRenderFns } from "./RegisterStepCompanies.vue?vue&type=template&id=0b0c015a&"
import script from "./RegisterStepCompanies.vue?vue&type=script&lang=js&"
export * from "./RegisterStepCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports